import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "daysBetween"
})
export class DaysBetweenPipe implements PipeTransform {
  private truncate(d: Date) {
    d.setUTCHours(0);
    d.setUTCMinutes(0);
    d.setUTCSeconds(0);
    d.setUTCMilliseconds(0);
  }

  transform(value: any, args?: any): any {
    if (!value.start || !value.end) return null;

    const start = new Date(value.start.getTime());
    this.truncate(start);

    const end = new Date(value.end.getTime());
    this.truncate(end);

    return (
      Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1
    );
  }
}
